module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"slate__local__no__coverage\" class=\"slate\">\n    <div class=\"slate__wrapper\">\n        ")
    ;  if(title) { 
    ; __append("\n            <div class=\"slate__title lcp_no_local_live\">\n                ")
    ; __append(escapeFn( title ))
    ; __append("\n            </div>\n        ")
    ;  } 
    ; __append("\n        ")
    ;  if(cta.copy) { 
    ; __append("\n            <div class=\"slate__cta\">\n                <a class=\"button\" href=\"")
    ; __append(escapeFn( cta.url ))
    ; __append("\"\n                   aa-link=\"")
    ; __append(escapeFn(cta.aaLink))
    ; __append("\">\n                    <div class=\"button__text\">")
    ; __append(escapeFn( cta.copy ))
    ; __append("</div>\n                </a>\n            </div>\n        ")
    ;  } 
    ; __append("\n    </div>\n</div>\n")
  }
  return __output;

}